export function getLocalState (key) {
  return window.localStorage?.getItem(key)
}

export function setLocalState (key, value) {
  window.localStorage?.setItem(key, value)
}
